import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Grid, Paper, TextField, MenuItem, Radio, RadioGroup, FormControlLabel, Pagination, Autocomplete, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ApiService from "../../functions/apiService";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import moment from "moment/moment";
import { useSnackbar } from "notistack";
import SystemHeaderNav from "../../components/HeadersNav/SystemHeaderNav";
import EmptyState from "../../components/Error/EmptyState";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setEmployeesListDDL } from "../../store/ddlReducer";
import AuditLogHeader from "../../components/AuditLog/AuditLogHeader";
import { toast } from 'react-toastify';

export default function AuditLog() {
  const dispatch = useDispatch();
  let today = new Date();
  let yesterday = new Date();

  yesterday.setDate(yesterday.getDate() - 1);

  let EmployeesListDDL = useSelector((state) => {
    return state.ddlReducer.EmployeesListDDL;
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [tables, setTables] = useState([]);
  const [chosenTable, setChosenTable] = useState();
  const [chosenType, setChosenType] = useState("All");
  const [dateFrom, setDateFrom] = useState(yesterday);
  const [dateTo, setDateTo] = useState(today);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [page, setPage] = useState(1);
  /////new desgin
  const [columns, setColumns] = useState([]);
  const [itemsRow, setItemsRow] = useState([]);
  const [results, setResults] = useState();
  // const { enqueueSnackbar } = useSnackbar();

  const loadDropDown = () => {
    setLoading(true);
    ApiService.get("/getJournalLogTypeDDL")
      .then(({ data }) => {
        setTables(data);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
        setLoading(false);
      });
    ApiService.get("/getEmployeeDDL", {}, "getEmployeeDDL")
      .then(({ data }) => {
        dispatch(setEmployeesListDDL(data));
      })
      .catch(() => {
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
      });
  };

  const loadData = () => {
    let route = `/getJournalLog?type=${chosenTable}&action=${chosenType}`;

    if (dateFrom) {
      const dateF = moment(dateFrom).format("YYYY-MM-DD");
      route += `&startDate=${dateF}`;
    }
    if (dateTo) {
      const dateT = moment(dateTo).format("YYYY-MM-DD");
      route += `&endDate=${dateT}`;
    }
    if (selectedEmp) {
      route += `&empcode=${selectedEmp}`;
    }
    route += `&page=${page}`;

    ApiService.get(route, {}, "getJournalLog")
      .then(({ data }) => {
        if (data.data.total > 0) {
          let inkeys;
          let inCol;
          ////////set colums
          if (data.data.data[0]?.newData != null) {
            inkeys = Object.keys(JSON.parse(data.data.data[0]?.newData));
            inCol = Object.keys(JSON.parse(data.data.data[0]?.newData)).map(
              (item) => {
                return {
                  field: item,
                  headerName: item,
                  flex: 1,
                  minWidth: 150,
                };
              }
            );

            setColumns([
              {
                field: "key",
                headerName: "key",
                flex: 1,
                minWidth: 100,
              },
              ...inCol,
            ]);
          }
          else {
            inkeys = Object.keys(JSON.parse(data.data.data[0]?.oldData));
            inCol = Object.keys(JSON.parse(data.data.data[0]?.oldData)).map(
              (item) => {
                return {
                  field: item,
                  headerName: item,
                  flex: 1,
                  minWidth: 150,
                };
              }
            );
            setColumns([
              {
                field: "key",
                headerName: "key",
                flex: 1,
                minWidth: 100,
              },
              ...inCol,
            ]);
          }

          setItemsRow(
            data.data.data.map((item) => {
              console.log("item", item);
              let rowsItem = [];
              if (item.newData != null) {
                rowsItem[0] = JSON.parse(item.newData);
                rowsItem[0]["id"] = item.id + "new";
                rowsItem[0]["key"] = "new";
              }
              if (item.oldData != null) {
                rowsItem[1] = JSON.parse(item.oldData);
                rowsItem[1]["id"] = item.id + "old";
                rowsItem[1]["key"] = "old";
              }
              return {
                ...item,
                rows: rowsItem,
              };
            })
          );
        }
        // data.data.data.forEach(rearrange)
        setResults(data.data);
        setSaving(false);
      })
      .catch(() => {
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
        setSaving(false);
      });
  };

  const compareFunc = (e) => {
    e.preventDefault();
    setSaving(true);
    loadData();
  };

  useEffect(() => {
    loadDropDown();
  }, []);

  const PageChanged = (e, page) => {
    setPage(page);
  };

  useEffect(() => {
    if (results && results.data && results.data.length > 0) {
      setSaving(true);
      loadData();
    }
  }, [page]);

  let updateEmpCode = (value) => {
    setSelectedEmp(value);
    loadData();
  };

  return (
    <>
      {/* <SystemHeaderNav /> */}
      <Paper className="p-4" style={{ marginTop: "1rem" }}>
        <div>
          <div>
            <Typography variant="h5">Journal Audit Log</Typography>
            <div className="mt-4 mb-3">
              <AuditLogHeader />
            </div>
            <div>
              {loading ?
                <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                  <CircularProgress />
                </Box>
                :
                <form onSubmit={compareFunc}>
                  <Grid container spacing={2} columns={{ xs: 20, sm: 20, md: 20 }} >
                    <Grid className="pt-2" item xs={20} sm={20} md={4} sx={{}}>
                      <Autocomplete
                        className="mt-1 w-100"
                        disablePortal
                        disableClearable={true}
                        options={[
                          { label: "any", value: null },
                          ...EmployeesListDDL.map((item) => {
                            return {
                              label: item.fullName,
                              value: item.Emp_Code,
                            };
                          }),
                        ]}
                        onChange={(e, value) => updateEmpCode(value.value)}
                        renderInput={(params) => (
                          <TextField
                            color="secondary"
                            {...params}
                            label="Employee"
                            InputProps={{
                              sx: {
                                height: '48px',
                              }
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid className="pt-2" item xs={20} sm={20} md={4} sx={{}}>
                      <TextField
                        label="Select Table *"
                        className="mt-1 w-100"
                        color="secondary"
                        variant="outlined"
                        select
                        InputProps={{
                          sx: {
                            height: '48px',
                          }
                        }}
                        value={chosenTable}
                        onChange={(e) => setChosenTable(e.target.value)}
                      >
                        {tables.map((table) => (
                          <MenuItem key={table} value={table}>
                            {table}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid className="pt-2" item xs={8} sm={8} md={4} sx={{ display: "flex", alignItems: "end", }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          format="dd MMM yyyy"
                          value={dateFrom}
                          onChange={(e) => setDateFrom(e)}
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              height: '48px'
                            }
                          }}
                          slotProps={{
                            inputAdornment: {
                              position: "start",
                            },
                            textField: () => ({
                              color: "secondary",
                            }),
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid className="pt-2" item xs={2} sm={2} md={1} sx={{ display: "flex", alignItems: "end", }}>
                      <div className="h-100 w-100 d-flex justify-content-center align-items-center ">
                        {" "}To{" "}
                      </div>
                    </Grid>
                    <Grid className="pt-2" item xs={8} sm={8} md={4} sx={{ display: "flex", alignItems: "end", }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          format="dd MMM yyyy"
                          value={dateTo}
                          onChange={(e) => setDateTo(e)}
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              height: '48px'
                            }
                          }}
                          minDate={dateFrom}
                          slotProps={{
                            inputAdornment: {
                              position: "start",
                            },
                            textField: () => ({
                              color: "secondary",
                            }),
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={20} sm={20} md={20}>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={chosenType}
                        onChange={(e) => {
                          setChosenType(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value="Create"
                          control={<Radio color="primary" />}
                          label="Create"
                        />
                        <FormControlLabel
                          value="Edit"
                          control={<Radio color="primary" />}
                          label="Edit"
                        />
                        <FormControlLabel
                          value="Delete"
                          control={<Radio color="primary" />}
                          label="Delete"
                        />
                        <FormControlLabel
                          value="All"
                          control={<Radio color="primary" />}
                          label="All"
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid item xs={20} sm={20} md={20} sx={{ padding: "2.4rem 0 0 1rem" }}>
                      <ButtonTheme
                        disabled={saving || !chosenTable}
                        type="submit"
                        variant="filled"
                        color="primary"
                        className="px-5 h-100"
                      >
                        {saving && "Loading..."}
                        {!saving && "Compare"}
                      </ButtonTheme>
                    </Grid>
                  </Grid>
                </form>
              }
            </div>
            {saving ?
              <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                <CircularProgress />
              </Box>
              : (
                results && results.data && (results.data.length > 0 ?
                  (!saving &&
                    <>
                      {itemsRow &&
                        itemsRow.length > 0 &&
                        itemsRow.map((obj) => {
                          return (
                            <CollapseComponent
                              key={obj.id}
                              name={`${obj.employee?.fullName} - ${obj.operation.toUpperCase()} AT ${obj.created_at}`}
                              columns={columns}
                              rows={obj.rows}
                              checkboxSelection={false}
                            />
                          );
                        })}
                      {/* {results.data.map(rearrange)} */}
                      <br />
                      <Pagination
                        page={results.current_page}
                        count={results.last_page}
                        variant="outlined"
                        shape="rounded"
                        onChange={PageChanged}
                        sx={{
                          fontWeight: "800",
                          "& .Mui-selected": {
                            border: "red 1px solid",
                            background: "transparent !important",
                            color: "red",
                          },
                        }}
                      />
                    </>
                  ) : (
                    <EmptyState text="No Data in this period" />
                  ))
              )}
          </div>
        </div>
      </Paper>
    </>
  );
}
